'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = slugify;

function slugify(string) {
  return string.toLowerCase().split(/[^\w]/g).filter(String).join('-');
}

;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/hierarchy/slugify.js
 ** module id = 541
 ** module chunks = 0
 **/